/**
 * RESPONSIBILITY: draw a block that is one picture.
 */
import { hasImage } from '@framework/core';
import { ADC_THEME } from '@app/sections';
import { AdcBand } from './AdcBand';
import { Picture } from '../commons/Picture';
import type { AdcBlockProps } from './kind';

export function AdcImage({ b }: AdcBlockProps) {
  // A picture block with no picture would draw the grey placeholder at visitors.
  if (!hasImage(b.image)) return null;
  return (
    <AdcBand theme={ADC_THEME.Image} heading={b.heading}>
      <Picture value={b.image} className="adc-pic adc-pic-whole" />
    </AdcBand>
  );
}
